import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import Divider from "@mui/material/Divider";
import { ThemeProvider } from "@mui/material/styles";
import EmisionCertificado from "./EmisionCertificado";
import TrazabilidadDocumentos from "./TrazabilidadDocumentos";
import { PRAMI_COLORS, pramiCertificadosTheme } from "./certificadosTheme";

export default function ExpedicionCertificados() {
  const [refreshSignal, setRefreshSignal] = useState(0);

  const handleEmitido = () => setRefreshSignal((prev) => prev + 1);

  return (
    <ThemeProvider theme={pramiCertificadosTheme}>
      <Box component="main" sx={{ flexGrow: 1, p: 3, bgcolor: PRAMI_COLORS.pageBg }}>
        <CssBaseline />
        <Toolbar />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <EmisionCertificado onEmitido={handleEmitido} />
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 1, borderColor: PRAMI_COLORS.surfaceBorder }} />
          </Grid>

          <Grid item xs={12}>
            <TrazabilidadDocumentos refreshSignal={refreshSignal} />
          </Grid>
        </Grid>
      </Box>
    </ThemeProvider>
  );
}
